import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";

const ConnectedEmail = ({ isLoading, isCalendarValid }) => {
  const { userInfo } = useSelector((state) => state.calendarManagement);
  const icon = isCalendarValid
    ? "/assets/icons/common/success.svg"
    : "/assets/icons/common/failed.svg";

  if (isLoading) {
    return (
      <div className="flex gap-2 px-4 py-2 justify-center items-center bg-slate-200 rounded-md">
        <span className="whitespace-nowrap text-xs md:text-sm font-semibold">Loading Email...</span>
        <Loader size="16" border="border-4" />
      </div>
    );
  }

  return (
    <div
      className={`flex gap-2 px-4 py-2 justify-center items-center ${
        isCalendarValid ? "bg-slate-200" : "bg-red-200"
      } rounded-md`}
    >
      <span className="text-xs md:text-sm font-semibold">{userInfo?.email}</span>
      <img src={icon} alt="Icon" className="size-4 md:size-4" />
    </div>
  );
};

export default ConnectedEmail;
